import React, { useCallback, useState } from "react";
import LineItemBuilderForm from "./LineItemForm";
import { Button, Collapse, Grid, Tooltip } from "@material-ui/core";

interface ILineItemBuilder {
    contractId: string;
    hasPurchase: boolean;
    useNewCarrierFR?: boolean;
    isFrozen?: boolean;
    contractType?: string;
    exemptContractTypes?: string[];
}

export default function LineItemBuilder({ contractId, hasPurchase, useNewCarrierFR=false, isFrozen=false, contractType, exemptContractTypes=[] }: ILineItemBuilder) {
    const [showLineItemBuilder, setShowLineItemBuilder] = useState(false);

    const showHideLineItemBuilderHandler = useCallback(() => setShowLineItemBuilder(!showLineItemBuilder), [showLineItemBuilder])

    const blockedByFreeze =
        !!isFrozen && !(contractType && exemptContractTypes.includes(contractType));

    const button = (
        <Button
            variant="contained"
            color="primary"
            onClick={showHideLineItemBuilderHandler}
            disabled={blockedByFreeze}
        >
            Line Item Builder
        </Button>
    );

    return (
        <Grid container direction="column">
            <Grid item container justify="flex-end">
                {blockedByFreeze ? (
                    <Tooltip title="Receivables are frozen for this client. Cannot add line items.">
                        <span>{button}</span>
                    </Tooltip>
                ) : (
                    button
                )}
            </Grid>
            <Grid item style={{ width: "100%" }}>
                <Collapse in={showLineItemBuilder}>
                    <LineItemBuilderForm contractId={contractId} hasPurchase={hasPurchase} useNewCarrierFR={useNewCarrierFR} />
                </Collapse>
            </Grid>
        </Grid>
    )
}
